export const getMonthName = (month = 1) => {
  const date = new Date();
  date.setDate(1); // Set the day of the month to the 1st to prevent rollover
  let monthNumber = Number(month);

  if (isNaN(monthNumber)) {
    monthNumber = 1;
  }

  date.setMonth(monthNumber - 1);

  return date.toLocaleString('en-US', {
    month: 'long',
  });
};
